import React from 'react';
import './DottedLoader.css';

const LoadingDots = ({
  size = 8,
  color = '#000',
  speed = 1.2,
}: {
  size?: number;
  color?: string;
  speed?: number;
}) => {
  return (
    <div
      className='loading-dots'
      style={
        {
          '--dot-size': `${size}px`,
          '--dot-color': color,
          '--dot-speed': `${speed}s`,
        } as React.CSSProperties // 👈 IMPORTANT FIX
      }
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default LoadingDots;
